import { useEffect, useRef } from "react";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import { useTogglePopup } from "./useTogglePopup";
import { GET_PARAMS, GET_POPUP_TYPES } from "../constants/popupConfig";
import { useGetJWTSportsBookData } from "../queries/useGetJWTSportsBook";
import { sendToast } from "../components/molecules/Toast";
import { getEnv } from "../utils/hostname";
import { useCatalogsStore } from "../stores/catalogs";

const IFRAME_PREFIX = "sportsbook";
export const usePostMessageGR8 = () => {
  const { openPopup } = useTogglePopup();
  const { refetch } = useGetJWTSportsBookData();
  const navigate = useNavigate();
  const location = useLocation();
  const lastPathRef = useRef<string | null>(null);
  const languages = useCatalogsStore((s) => s.languages);

  const lang = localStorage.getItem("lang") || "en";
  const isStage =
    getEnv() === "stage" || getEnv() === "dev" || getEnv() === "local";
  const sportsBookHost = isStage
    ? "https://sport-iframe.pjdoi.xyz"
    : "https://sport-iframe.apcje.xyz";
  const normalizePath = (path: string): string => {
    let cleaned = path;
    if (/^\/favorites(\/.*)?/.test(cleaned)) {
      cleaned = "/favorites";
    }

    cleaned = cleaned.replace(new RegExp(`(/${IFRAME_PREFIX})+`, "gi"), "");
    let langCodes = languages
      ?.map((currentLang) => currentLang.isoCode)
      .join("|");

    langCodes += "|kk";
    const langRegex = new RegExp(`^/(${langCodes})(/|$)`, "i");
    cleaned = cleaned.replace(langRegex, "");

    cleaned = cleaned.replace(/\/{2,}/g, "/");

    if (!cleaned.startsWith("/")) {
      cleaned = `/${cleaned}`;
    }
    if (cleaned === "/") {
      return "/";
    }
    return cleaned;
  };

  useEffect(() => {
    const messageHandler = (data) => {
      if (data.origin !== sportsBookHost) {
        return;
      }
      const { data: messageData } = data;
      try {
        switch (messageData.type) {
          case "navigation":
            // eslint-disable-next-line no-case-declarations
            const incomingPath = messageData.path;
            // eslint-disable-next-line no-console
            console.log({
              incomingPath: "user.navigation!",
              data: messageData,
            });
            // eslint-disable-next-line no-case-declarations
            const cleanedPath = normalizePath(incomingPath);
            // eslint-disable-next-line no-case-declarations
            const fullClientPath = `/${IFRAME_PREFIX}${cleanedPath}`;
            if (
              fullClientPath === location.pathname ||
              fullClientPath === lastPathRef.current
            ) {
              return;
            }

            lastPathRef.current = fullClientPath;
            navigate(fullClientPath, { replace: true });
            break;
          case "login.click":
            openPopup(GET_POPUP_TYPES.popup.signUp);

            break;
          case "user.balance":
            // eslint-disable-next-line no-console
            console.log("user.balance!");
            break;

          case "auth.fail":
            // eslint-disable-next-line no-console
            console.log("auth.fail", messageData);
            refetch().catch(() => {
              sendToast({
                title: "Error auth on GR8",
                variant: "red",
              });
            });

            break;
          case "deposit.click":
            navigate({
              search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.deposit })}`,
            });

            break;

          default:
            // eslint-disable-next-line no-console
            console.log("Error:", messageData);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(
          "Error parsing JSON from postMessage:",
          error,
          "Received data:",
          messageData,
        );
      }
    };

    window.addEventListener("message", messageHandler);

    return () => {
      window.removeEventListener("message", messageHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, location.pathname, lang]);
};
